import { CopilotAction, CopilotActionType } from 'models/copilot/copilotAction';
import { TenantProcess, TenantProcessStatus } from 'models/copilot/tenantProcessStateBase';

// The state rules of the panel's actions, shared by the action list and the composer's Actions menu.

// While the selected process runs, another process cannot be started from the panel.
export const isProcessActionDisabled = (
  action: CopilotAction,
  selectedRunningProcessId: TenantProcess | undefined,
): boolean => {
  if (action.type !== CopilotActionType.Process || action.processId === undefined) return false;

  return selectedRunningProcessId !== undefined && selectedRunningProcessId !== action.processId;
};

// A finished process (completed, failed or stopped) starts a new run at the first click of its button, also where a
// usage lists several processes: its earlier result stays reachable through "Open the result" (openProcessRun).
export const isFinishedProcessStatus = (status: TenantProcessStatus | undefined): boolean =>
  status === TenantProcessStatus.Completed ||
  status === TenantProcessStatus.Failed ||
  status === TenantProcessStatus.Cancelled;

// A process is selected when it is the panel's active process; any other action by its own flag.
export const isActionSelected = (action: CopilotAction, activeProcessId: TenantProcess | undefined): boolean => {
  if (action.type !== CopilotActionType.Process || action.processId === undefined) return action.selected === true;

  return activeProcessId === action.processId;
};
